import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../context/context";
import { courseHelper } from "../helpers";

export const useGetAll = () => {
  const { userInfoQursiva, logOut } = useContext(AuthContext);
  // Sin sesión el AuthProvider expone `userInfoQursiva === false`; destructurarlo
  // crasheaba al montar la home nueva sin sesión. `courseHelper.get()` funciona
  // sin token (endpoint público del catálogo).
  const token = userInfoQursiva ? userInfoQursiva.tokenQursiva : undefined;
  const [data, setData] = useState([]);
  const [introductory, setIntroductory] = useState([]);
  const [basicAndIntermediate, setBasicAndIntermediate] = useState([]);
  const [trainings, setTrainings] = useState([]);
  const [paidCourses, setPaidCourses] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    courseHelper.get().then((response) => {
      if (userInfoQursiva !== false) {
        courseHelper
          .validateAccess(userInfoQursiva.userRelationId)
          .then((resp) => {
            let courses = response;

            const hasExpansion = resp.find(
              (item) =>
                item.courseId === parseInt(process.env.REACT_APP_CHALLENGE_ID)
            );

            const hasLeaderTeam = resp.find(
              (item) =>
                item.courseId ===
                parseInt(process.env.REACT_APP_LEADER_TEAMS_ID)
            );

            if (!hasExpansion) {
              courses = courses.filter(
                (item) =>
                  item.id !== parseInt(process.env.REACT_APP_CHALLENGE_ID)
              );
            }

            if (!hasLeaderTeam) {
              courses = courses.filter(
                (item) =>
                  item.id !== parseInt(process.env.REACT_APP_LEADER_TEAMS_ID)
              );
            }
            const updateCourses = courses.filter((item) => item.test === false);
            setData(updateCourses);
            setIntroductory(
              response.filter((item) => item.categoryCourse.category.id === 2)
            );
            setBasicAndIntermediate(
              response.filter(
                (item) =>
                  item.categoryCourse.category.id === 3 ||
                  item.categoryCourse.category.id === 4
              )
            );
            setTrainings(
              response.filter((item) => item.categoryCourse.category.id === 5)
            );
            setPaidCourses(response.filter((item) => item.value > 0));
            setIsLoading(false);
          });
      } else {
        let courses = response.filter(
          (item) => item.id !== parseInt(process.env.REACT_APP_CHALLENGE_ID)
        );

        courses = courses.filter(
          (item) => item.id !== parseInt(process.env.REACT_APP_LEADER_TEAMS_ID)
        );
        const updateCourses = courses.filter((item) => item.test === false);
        setData(updateCourses);
        setIntroductory(
          response.filter((item) => item.categoryCourse.category.id === 2)
        );
        setBasicAndIntermediate(
          response.filter(
            (item) =>
              item.categoryCourse.category.id === 3 ||
              item.categoryCourse.category.id === 4
          )
        );
        setTrainings(
          response.filter((item) => item.categoryCourse.category.id === 5)
        );
        setPaidCourses(response.filter((item) => item.value > 0));
        setIsLoading(false);
      }
    });
  }, [userInfoQursiva]);

  useEffect(() => {
    courseHelper.get().then((response) => {
      if (userInfoQursiva !== false) {
        courseHelper
          .validateAccess(userInfoQursiva.userRelationId)
          .then((resp) => {
            let courses = response;

            const hasExpansion = resp.find(
              (item) =>
                item.courseId === parseInt(process.env.REACT_APP_CHALLENGE_ID)
            );

            const hasLeaderTeam = resp.find(
              (item) =>
                item.courseId ===
                parseInt(process.env.REACT_APP_LEADER_TEAMS_ID)
            );

            if (!hasExpansion) {
              courses = courses.filter(
                (item) =>
                  item.id !== parseInt(process.env.REACT_APP_CHALLENGE_ID)
              );
            }

            if (!hasLeaderTeam) {
              courses = courses.filter(
                (item) =>
                  item.id !== parseInt(process.env.REACT_APP_LEADER_TEAMS_ID)
              );
            }

            const updateCourses = courses.filter((item) => item.test === false);
            setData(updateCourses);
            setIntroductory(
              response.filter((item) => item.categoryCourse.category.id === 2)
            );
            setBasicAndIntermediate(
              response.filter(
                (item) =>
                  item.categoryCourse.category.id === 3 ||
                  item.categoryCourse.category.id === 4
              )
            );
            setTrainings(
              response.filter((item) => item.categoryCourse.category.id === 5)
            );
            setPaidCourses(response.filter((item) => item.value > 0));
            setIsLoading(false);
          });
      } else {
        let courses = response.filter(
          (item) => item.id !== parseInt(process.env.REACT_APP_CHALLENGE_ID)
        );

        courses = response.filter(
          (item) => item.id !== parseInt(process.env.REACT_APP_LEADER_TEAMS_ID)
        );
        const updateCourses = courses.filter((item) => item.test === false);
        setData(updateCourses);
        setIntroductory(
          response.filter((item) => item.categoryCourse.category.id === 2)
        );
        setBasicAndIntermediate(
          response.filter(
            (item) =>
              item.categoryCourse.category.id === 3 ||
              item.categoryCourse.category.id === 4
          )
        );
        setTrainings(
          response.filter((item) => item.categoryCourse.category.id === 5)
        );
        setPaidCourses(response.filter((item) => item.value > 0));
        setIsLoading(false);
      }
    });
  }, [token, logOut, userInfoQursiva]);

  return {
    isLoading,
    data,
    introductory,
    basicAndIntermediate,
    trainings,
    paidCourses,
  };
};
